export * from 'angular2-platform-node';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
